import {
  Calendar,
  Callout,
  DayOfWeek,
  DefaultButton,
  DirectionalHint,
  FocusTrapZone,
  PrimaryButton,
  Stack,
} from "@fluentui/react";
import React from "react";
import {
  ICustomers,
  ICustomerReport,
  ICustomerReportWorkFlowLog,
  ITokenUser,
  IDataCenter,
} from "../../../vm";
import { childrenGap, DayPickerStrings } from "../../common/Constants";
import Stepper from "../../common/stepper/Stepper";
import moment from "moment";
import {
  searchCustomerReport,
  generateOrUpdateCustomerReport,
  searchCustomerReportWorkFLowLogs,
} from "../../../services/customers/CustomerService";
import { Loading } from "../../../services/Loading";
import { downloadFile, parseJwt } from "../../../services/UtilService";
import ManageReportApproval from "./ManageReportApproval";
import { WorkFlowLogs } from "./WorkFlowLogs";
import ManageSendEmail from "./ManageSendEmail";
// import ManageConfigDialog from './ManageConfigDialog';
import { addMonths } from "@fluentui/date-time-utilities";
import { ToastContext } from "../../common/ToastProvider";
import ManageDownloadReportDialog from "./ManageDownloadReportDialog";
import ManageMergeDCReportDialog from "./ManageMergeDCReportDialog";

// const DC_STATUS_DICT: any = {
//   0: 'Awaiting for Submission from Operation Team',
//   1: `Awaiting for Datacenter Manager's Approval`,
//   2: 'Approved by Datacenter Manager',
//   '-2': 'Rejected by Datacenter Manager',
//   '-3': 'Rejected by CEM',
// };

let calendarButtonElement: HTMLElement;
export interface ReportApprovalStatusProps {
  customerId: string;
  customer: ICustomers;
  datacenterId: string;
  datacenter: IDataCenter;
  datacenters: IDataCenter[];
}

const ReportApprovalStatus: React.FC<ReportApprovalStatusProps> = ({
  customer,
  customerId,
  datacenterId,
  datacenter,
  datacenters
}) => {
  // custom hooks
  const { showToast } = React.useContext(ToastContext);

  // const date = new Date();
  // // date.setMonth(date.getMonth() - 1);
  // const dateString = `${date.getMonth()}/${date.getDate()}/${date.getFullYear()}`;
  // // console.log('datestring', dateString);

  const [isLoading, setLoading] = React.useState(false);
  const [activeStep, setActiveStep] = React.useState(0);
  const [showCalender, setShowCalender] = React.useState(false);
  const [search, setSearch] = React.useState({
    customerId: customerId,
    date: moment().subtract(1, "month").toDate(),
  } as {
    customerId: string;
    date: Date | string;
  });
  const [customerReport, setCustomerReport] = React.useState<ICustomerReport>({
    customerId: customerId,
    date: new Date(),
    datacenterStatus: [],
    remarks: "",
  });
  const [approvalModel, setApprovalModel] = React.useState({ isOpen: false });
  const [sendEmailModel, setSendEmailModel] = React.useState({ isOpen: false });
  const [workFlowLogs, setWorkFlowLogs] = React.useState<
    Array<ICustomerReportWorkFlowLog>
  >([]);
  const [userTokenData, setUserTokenData] = React.useState({} as ITokenUser);
  const [dcDict, setDcDict] = React.useState({} as any);
  // const [configModal, setConfigModal] = React.useState({ isOpen: false });
  const [downloadReportModal, setDownloadReportModal] = React.useState({
    isOpen: false,
  });
  const [mergeReportModal, setMergeReportModal] = React.useState({
    isOpen: false,
  });

  // local hooks
  React.useEffect(() => {
    const user: any = parseJwt();
    setUserTokenData(user);
    onSearch();
  }, []);

  React.useEffect(() => {
    if (customerReport?._id) getWorkFlowLogs(customerReport._id);
  }, [customerReport]);

  // local function
  const closeCalender = (ev?: any) => {
    setShowCalender(false);
  };
  const onSearch = async () => {
    setLoading(true);

    const result = await searchCustomerReport({
      customerId: search.customerId,
      date: moment(search.date).format("YYYY-MM-DD"),
      datacenterId: datacenterId,
    });
    if (result?.success) {
      if (result.data) {
        const tempCustomerReport: ICustomerReport = result.data;
        let tempActiveStep = getActiveStep(tempCustomerReport);
        // if (tempCustomerReport.status !== 0) {
        //   await getWorkFlowLogs(tempCustomerReport._id);
        // }
        if (
          tempCustomerReport.datacenters &&
          tempCustomerReport.datacenters.length > 0
        ) {
          const tempDict: any = {};
          tempCustomerReport.datacenters.forEach((d: any) => {
            tempDict[d._id.toString()] = d;
          });
          setDcDict(tempDict);
        }
        setActiveStep(tempActiveStep);
        // setCustomerReport({...tempCustomerReport, remarks: "" });
        setCustomerReport({ ...tempCustomerReport });
      }
    } else {
      showToast(
        result?.message || "Error while getting customer report",
        "error"
      );
    }
    setLoading(false);
  };

  const getWorkFlowLogs = async (customerReportId?: string) => {
    // setLoading(true);
    const result = await searchCustomerReportWorkFLowLogs({
      customerReportId: customerReportId as string,
    });
    if (result?.success) {
      setWorkFlowLogs(result.data);
    } else {
      showToast(
        result?.message ||
        "Error while getting customer report workflow logs report",
        "error"
      );
    }
    // setLoading(false);
  };

  const getActiveStep = (data: ICustomerReport) => {
    let tempActiveStep = 0;
    let userData = userTokenData;
    if (Object.keys(userData).length === 0) {
      userData = parseJwt() as any;
    }

    // when not CEM
    if (userData.isAdmin === true && [0, 2, 3, 4, 5].includes(userData.role)) {
      // when admin or CEM
      let maxNumber = 0;
      data.datacenterStatus.forEach((d) => {
        if (d.status > maxNumber) {
          maxNumber = d.status;
        }
      });
      if (data.file) {
        tempActiveStep = maxNumber + 1;
      }
      if (data.datacenterStatus[0] && data.datacenterStatus[0].status === -3) {
        tempActiveStep = 2;
      }
      if (data.datacenterStatus[0] && data.datacenterStatus[0].status === -4) {
        tempActiveStep = 3;
      }
      // check if all dc approved, if not then show awaiting DC approval stage
      // if (tempActiveStep === 3) {
      //   data.datacenterStatus.forEach((d) => {
      //     if (d.status < 2) {
      //       tempActiveStep = 2;
      //       return;
      //     }
      //   });
      // }
      // todo
    } else {
      const foundDCStatus = data.datacenterStatus.find(
        (d) => userData.datacenterIds.includes(d.datacenterId)
      );
      if (foundDCStatus) {
        const status = foundDCStatus.status;
        const file = data.file;
        if (status === 0) {
          if (file) {
            tempActiveStep = 1;
          } else {
            tempActiveStep = 0;
          }
        } else if (status < 0) {
          if (status === -3) {
            tempActiveStep = 2;
          } else if (status === -2) {
            tempActiveStep = 1;
          }
        } else {
          tempActiveStep = status + 1;
        }
      }
    }
    // on click send email status will be change to 5 and active state should also be 5 (max step)
    if (tempActiveStep > 5) {
      tempActiveStep = 5
    }

    return tempActiveStep;
  };

  const generateReport = async (data?: {
    activeStep?: number;
    customerReport?: ICustomerReport;
  }) => {
    setLoading(true);
    let tempActiveStep = data?.activeStep;
    // todo update report
    if (data?.customerReport != null) {
      const result = await generateOrUpdateCustomerReport(data.customerReport);
      if (result?.data) {
        const tempCustomerReport: ICustomerReport = result.data;
        tempActiveStep = getActiveStep(tempCustomerReport);
        setActiveStep(tempActiveStep);
        setCustomerReport(tempCustomerReport);
        showToast(
          "Customer report generated / updated successfully",
          "success"
        );
      } else {
        showToast(
          result?.message ||
          "Error while generating / updating customer report",
          "error"
        );
        return setLoading(false);
      }
    }
    if (data?.activeStep != null) {
      setActiveStep(tempActiveStep as number);
    }
    setLoading(false);
  };

  const downloadReport = async () => {
    setLoading(true);
    const fileName =
      customer.name.replace(/\./g, "") +
      " " +
      datacenter.location +
      " " +
      moment(customerReport.date).format("MMM-YYYY");
    // console.log('customerName', fileName);
    await downloadFile(fileName, customerReport.fileUrl as string);
    setLoading(false);
  };

  const handleOpenCloseApprovalModel = (
    isOpen: boolean,
    data?: ICustomerReport
  ) => {
    if (data) {
      const tempActiveStep = getActiveStep(data);
      setActiveStep(tempActiveStep);

      // setCustomerReport({...data, remarks: "" });
      setCustomerReport(data);
    }
    setApprovalModel({ ...approvalModel, isOpen: isOpen });
  };
  const handleOpenCloseSendEmailModel = (isOpen: boolean, data?: ICustomerReport) => {
    if (data) {
      setCustomerReport(data);
    }
    setSendEmailModel({ ...sendEmailModel, isOpen: isOpen });
  };
  // const handleConfigDialogOpenClose = (isOpen: boolean) => {
  //   setConfigModal({ ...configModal, isOpen });
  // };
  const handleDownloadReportDialogOpenClose = (isOpen: boolean) => {
    setDownloadReportModal({ ...downloadReportModal, isOpen });
  };
  const handleOpenCloseMergerReportModel = (isOpen: boolean, data?: ICustomerReport) => {
    if (data) {
      setCustomerReport(data);
    }
    setMergeReportModal({ ...mergeReportModal, isOpen: isOpen });
  };

  const maxDate: Date = addMonths(new Date(Date.now()), -1);

  const isCemAdmin = [4].includes(userTokenData.role)

  return (
    <div className="pt-16">
      {isLoading && <Loading />}
      <Stack tokens={childrenGap}>
        <Stack.Item>
          <Stack
            horizontal
            wrap
            tokens={childrenGap}
            horizontalAlign="space-between"
          >
            <Stack.Item>
              <Stack horizontal wrap tokens={childrenGap}>
                <Stack.Item>
                  <div
                    ref={(calendarBtn) =>
                      (calendarButtonElement = calendarBtn!)
                    }
                  >
                    <DefaultButton
                      text={
                        !search.date
                          ? "Select a month"
                          : moment(search.date).format("MMM-YYYY")
                      }
                      onClick={() => setShowCalender(true)}
                      className="month-picker-btn"
                    />
                  </div>
                  {showCalender && (
                    <Callout
                      isBeakVisible={false}
                      gapSpace={0}
                      doNotLayer={false}
                      target={calendarButtonElement}
                      directionalHint={DirectionalHint.bottomLeftEdge}
                      onDismiss={() => closeCalender()}
                      setInitialFocus
                    >
                      <FocusTrapZone
                        firstFocusableSelector="ms-DatePicker-day--today"
                        isClickableOutsideFocusTrap
                      >
                        <Calendar
                          // eslint-disable-next-line react/jsx-no-bind
                          onSelectDate={(date: Date | null | undefined) => {
                            setSearch({ ...search, date: date as Date });
                            setShowCalender(false);
                          }}
                          onDismiss={() => closeCalender()}
                          isMonthPickerVisible={true}
                          // value={state.search.date}
                          firstDayOfWeek={DayOfWeek.Sunday}
                          strings={DayPickerStrings}
                          isDayPickerVisible={false}
                          highlightCurrentMonth={false}
                          highlightSelectedMonth={false}
                          showMonthPickerAsOverlay={false}
                          showGoToToday={false}
                          maxDate={maxDate}
                        />
                      </FocusTrapZone>
                    </Callout>
                  )}
                </Stack.Item>
                <Stack.Item>
                  <PrimaryButton text="Search" onClick={onSearch} />
                </Stack.Item>
              </Stack>
            </Stack.Item>
            {/* <Stack.Item>
              <PrimaryButton
                text="Config"
                onClick={() => handleConfigDialogOpenClose(true)}
              />
            </Stack.Item> */}
          </Stack>
        </Stack.Item>
        <Stack.Item>
          <Stepper
            activeStep={activeStep}
            data={[
              {
                title:
                  activeStep === 0 ? "Generate Report" : "Report Generated",
                content: (
                  <div>
                    <PrimaryButton
                      text="Generate Report"
                      disabled={isCemAdmin}
                      onClick={() => {
                        generateReport({
                          activeStep: 1,
                          customerReport: {
                            ...customerReport,
                            isGenerateNewReport: true,
                          },
                        });
                      }}
                    />
                  </div>
                ),
              },
              {
                title:
                  activeStep <= 1
                    ? `Awaiting for Operation Team's Submission`
                    : `Submitted by Operation Teams`,
                content: (
                  <Stack tokens={childrenGap}>
                    <Stack.Item>
                      <WorkFlowLogs data={workFlowLogs} dcDict={dcDict} />
                    </Stack.Item>
                    <Stack.Item>
                      <Stack tokens={childrenGap} horizontal>
                        {/* <Stack.Item>
                          <DefaultButton
                            text="Download Report"
                            className="borderless-btn"
                            onClick={() => {
                              downloadReport();
                            }}
                          />
                        </Stack.Item>
                        <Stack.Item>
                          <PrimaryButton
                            text="Generate Report"
                            onClick={() => {
                              generateReport({
                                activeStep: 1,
                                customerReport: {
                                  ...customerReport,
                                  isGenerateNewReport: true,
                                },
                              });
                            }}
                          />
                        </Stack.Item> */}
                        <Stack.Item>
                          <DefaultButton
                            text="Report"
                            split
                            splitButtonAriaLabel="See 2 options"
                            aria-roledescription="split button"
                            menuProps={{
                              items: [
                                {
                                  key: "generateReport",
                                  text: "Generate Report",
                                  iconProps: { iconName: "Generate" },
                                  disabled: isCemAdmin,
                                  onClick: () => {
                                    generateReport({
                                      activeStep: 1,
                                      customerReport: {
                                        ...customerReport,
                                        isGenerateNewReport: true,
                                      },
                                    });
                                  },
                                },
                                {
                                  key: "downloadReport",
                                  text: "Download Report",
                                  iconProps: { iconName: "DownloadDocument" },
                                  onClick: () => {
                                    downloadReport();
                                  },
                                },
                              ],
                            }}
                          />
                        </Stack.Item>
                        <Stack.Item>
                          <PrimaryButton
                            // text={
                            //   customerReport.status === -2
                            //     ? 'Re-submit for Approval'
                            //     : 'Submit for Approval'
                            // }
                            text={"Submit for Approval"}
                            disabled={
                              !(
                                // userTokenData.isAdmin === false &&
                                (userTokenData.role === 0)
                              )
                            }
                            onClick={() => {
                              handleOpenCloseApprovalModel(true);
                            }}
                          />
                        </Stack.Item>
                      </Stack>
                    </Stack.Item>
                  </Stack>
                ),
              },
              {
                title:
                  activeStep <= 2
                    ? `Awaiting for Datacenter Manager's Approval`
                    : `Approved by Datacenter Manager`,
                content: (
                  <Stack tokens={childrenGap}>
                    <Stack.Item>
                      <WorkFlowLogs data={workFlowLogs} dcDict={dcDict} />
                    </Stack.Item>
                    {/* {userTokenData.isAdmin === true &&
                    [0, 2].includes(userTokenData.role) ? (
                      <Stack.Item>
                        <Stack tokens={childrenGap} horizontal>
                          {customerReport.datacenterStatus.map(
                            (d, index: number) => {
                              return (
                                <Stack.Item key={index}>
                                  <div className='dc-status-card'>
                                    <Label>
                                      {dcDict[d.datacenterId]?.name ||
                                        d.datacenterId}
                                    </Label>
                                    <p>
                                      {
                                        DC_STATUS_DICT[
                                          d.status >= 0
                                            ? d.status
                                            : String(d.status)
                                        ]
                                      }
                                    </p>
                                  </div>
                                </Stack.Item>
                              );
                            }
                          )}
                        </Stack>
                      </Stack.Item>
                    ) : (
                      <Stack.Item>
                        <Stack tokens={childrenGap} horizontal>
                          <Stack.Item>
                            <DefaultButton
                              text='Download Report'
                              className='borderless-btn'
                              onClick={() => {
                                downloadReport();
                              }}
                            />
                          </Stack.Item>
                          <Stack.Item>
                            <PrimaryButton
                              // text={
                              //   customerReport.status === -3
                              //     ? 'Re-submit for Approval'
                              //     : 'Submit for Approval'
                              // }
                              text={'Submit for Approval'}
                              disabled={
                                !(
                                  userTokenData.isAdmin === true &&
                                  [1].includes(userTokenData.role)
                                )
                              }
                              onClick={() => {
                                handleOpenCloseApprovalModel(true);
                              }}
                            />
                          </Stack.Item>
                        </Stack>
                      </Stack.Item>
                    )} */}

                    <Stack.Item>
                      <Stack tokens={childrenGap} horizontal>
                        <Stack.Item>
                          {/* <DefaultButton
                            text='Download Report'
                            className='borderless-btn'
                            onClick={() => {
                              downloadReport();
                            }}
                          /> */}
                          <DefaultButton
                            text="Report"
                            split
                            splitButtonAriaLabel="See 2 options"
                            aria-roledescription="split button"
                            menuProps={{
                              items: [
                                {
                                  key: "generateReport",
                                  text: "Generate Report",
                                  disabled: isCemAdmin,
                                  iconProps: { iconName: "Generate" },
                                  onClick: () => {
                                    generateReport({
                                      // activeStep: 1,
                                      customerReport: {
                                        ...customerReport,
                                        isGenerateNewReport: true,
                                      },
                                    });
                                  },
                                },
                                {
                                  key: "downloadReport",
                                  text: "Download Report",
                                  iconProps: { iconName: "DownloadDocument" },
                                  onClick: () => {
                                    downloadReport();
                                  },
                                },
                              ],
                            }}
                          />
                        </Stack.Item>
                        <Stack.Item>
                          <PrimaryButton
                            // text={
                            //   customerReport.status === -3
                            //     ? 'Re-submit for Approval'
                            //     : 'Submit for Approval'
                            // }
                            text={"Submit for Approval"}
                            disabled={
                              !(
                                userTokenData.isAdmin === true &&
                                [0, 1, 3].includes(userTokenData.role)
                              )
                            }
                            onClick={() => {
                              handleOpenCloseApprovalModel(true);
                            }}
                          />
                        </Stack.Item>
                      </Stack>
                    </Stack.Item>
                  </Stack>
                ),
              },
              {
                title:
                  activeStep <= 3
                    ? `Awaiting for MIS's Approval`
                    : `Approved by MIS`,
                content: (
                  <Stack tokens={childrenGap}>
                    <Stack.Item>
                      <WorkFlowLogs data={workFlowLogs} dcDict={dcDict} />
                    </Stack.Item>
                    <Stack.Item>
                      <Stack tokens={childrenGap} horizontal>
                        <Stack.Item>
                          <DefaultButton
                            text="Report"
                            split
                            splitButtonAriaLabel="See 2 options"
                            aria-roledescription="split button"
                            menuProps={{
                              items: datacenters.length > 1 ? [
                                {
                                  key: "generateReport",
                                  text: "Generate Report",
                                  disabled: isCemAdmin,
                                  iconProps: { iconName: "Generate" },
                                  onClick: () => {
                                    generateReport({
                                      // activeStep: 1,
                                      customerReport: {
                                        ...customerReport,
                                        isGenerateNewReport: true,
                                      },
                                    });
                                  },
                                },
                                {
                                  key: "generateMergeReport",
                                  text: "Generate Merge Report",
                                  disabled: !(
                                    userTokenData.isAdmin === true &&
                                    [0, 5].includes(userTokenData.role)
                                  ),
                                  iconProps: { iconName: "DocumentSet" },
                                  onClick: () => {
                                    handleOpenCloseMergerReportModel(true);
                                  },
                                },
                                {
                                  key: "downloadReport",
                                  text: "Download Report",
                                  iconProps: { iconName: "DownloadDocument" },
                                  onClick: () => {
                                    downloadReport();
                                  },
                                },
                              ] : [
                                {
                                  key: "generateReport",
                                  text: "Generate Report",
                                  disabled: isCemAdmin,
                                  iconProps: { iconName: "Generate" },
                                  onClick: () => {
                                    generateReport({
                                      // activeStep: 1,
                                      customerReport: {
                                        ...customerReport,
                                        isGenerateNewReport: true,
                                      },
                                    });
                                  },
                                },
                                {
                                  key: "downloadReport",
                                  text: "Download Report",
                                  iconProps: { iconName: "DownloadDocument" },
                                  onClick: () => {
                                    downloadReport();
                                  },
                                },
                              ],
                            }}
                          />
                        </Stack.Item>
                        <Stack.Item>
                          <PrimaryButton
                            text="Submit for Approval"
                            disabled={
                              !(
                                userTokenData.isAdmin === true &&
                                [0, 5].includes(userTokenData.role)
                              )
                            }
                            onClick={() => {
                              handleOpenCloseApprovalModel(true);
                            }}
                          />
                        </Stack.Item>
                      </Stack>
                    </Stack.Item>
                  </Stack>
                ),
              },
              {
                title:
                  // activeStep <= 2
                  // activeStep <= 3
                  activeStep <= 4
                    // ? `Awaiting for Submission to CEM Team`
                    ? `Awaiting for CEM's Approval`
                    // : `Submitted to CEM`,
                    : `Approved by CEM`,
                content: (
                  <Stack tokens={childrenGap}>
                    <Stack.Item>
                      <WorkFlowLogs data={workFlowLogs} dcDict={dcDict} />
                    </Stack.Item>
                    <Stack.Item>
                      <Stack tokens={childrenGap} horizontal>
                        <Stack.Item>
                          {/* <DefaultButton
                            text='Download Report'
                            className='borderless-btn'
                            onClick={() => {
                              downloadReport();
                            }}
                          /> */}
                          <DefaultButton
                            text="Report"
                            split
                            splitButtonAriaLabel="See 2 options"
                            aria-roledescription="split button"
                            menuProps={{
                              items: datacenters.length > 1 ? [
                                {
                                  key: "generateReport",
                                  text: "Generate Report",
                                  disabled: isCemAdmin,
                                  iconProps: { iconName: "Generate" },
                                  onClick: () => {
                                    generateReport({
                                      // activeStep: 1,
                                      customerReport: {
                                        ...customerReport,
                                        isGenerateNewReport: true,
                                      },
                                    });
                                  },
                                },
                                {
                                  key: "generateMergeReport",
                                  text: "Generate Merge Report",
                                  disabled: !(
                                    userTokenData.isAdmin === true &&
                                    [0, 2].includes(userTokenData.role)
                                  ),
                                  iconProps: { iconName: "DocumentSet" },
                                  onClick: () => {
                                    handleOpenCloseMergerReportModel(true);
                                  },
                                },
                                {
                                  key: "downloadReport",
                                  text: "Download Report",
                                  iconProps: { iconName: "DownloadDocument" },
                                  onClick: () => {
                                    downloadReport();
                                  },
                                },
                              ] : [
                                {
                                  key: "generateReport",
                                  text: "Generate Report",
                                  disabled: isCemAdmin,
                                  iconProps: { iconName: "Generate" },
                                  onClick: () => {
                                    generateReport({
                                      // activeStep: 1,
                                      customerReport: {
                                        ...customerReport,
                                        isGenerateNewReport: true,
                                      },
                                    });
                                  },
                                },
                                {
                                  key: "downloadReport",
                                  text: "Download Report",
                                  iconProps: { iconName: "DownloadDocument" },
                                  onClick: () => {
                                    downloadReport();
                                  },
                                },
                              ],
                            }}
                          />
                        </Stack.Item>
                        <Stack.Item>
                          <PrimaryButton
                            text="Proceed for Approval"
                            disabled={
                              !(
                                userTokenData.isAdmin === true &&
                                [0, 2].includes(userTokenData.role)
                              )
                            }
                            onClick={() => {
                              handleOpenCloseApprovalModel(true);
                            }}
                          />
                        </Stack.Item>
                      </Stack>
                    </Stack.Item>
                  </Stack>
                ),
              },
            ]}
          />
          {/* {activeStep === 4 && ( */}
          {activeStep === 5 && (
            <div style={{ marginLeft: 36 }}>
              <Stack tokens={childrenGap}>
                <Stack.Item>
                  <WorkFlowLogs data={workFlowLogs} dcDict={dcDict} />
                </Stack.Item>
                <Stack.Item>
                  <Stack tokens={childrenGap} horizontal>
                    <Stack.Item>
                      <DefaultButton
                        text="Download Report"
                        className="borderless-btn"
                        onClick={() => {
                          downloadReport();
                          // handleDownloadReportDialogOpenClose(true);
                        }}
                      />
                    </Stack.Item>
                    <Stack.Item>
                      <DefaultButton
                        text="Go to Previous Step"
                        disabled={
                          !(
                            userTokenData.isAdmin === true &&
                            [0, 2].includes(userTokenData.role)
                          )
                        }
                        onClick={() => {
                          handleOpenCloseApprovalModel(true);
                        }}
                      />
                    </Stack.Item>
                    <Stack.Item>
                      <PrimaryButton
                        text="Send email to Customer"
                        disabled={
                          !(
                            userTokenData.isAdmin === true &&
                            [0, 2, 5].includes(userTokenData.role)
                          )
                        }
                        onClick={() => {
                          handleOpenCloseSendEmailModel(true);
                        }}
                      />
                    </Stack.Item>
                  </Stack>
                </Stack.Item>
                <Stack.Item>
                  <br />
                  <br />
                  <br />
                  <br />
                  <br />
                </Stack.Item>
              </Stack>
            </div>
          )}
        </Stack.Item>
      </Stack>
      {approvalModel.isOpen && (
        <ManageReportApproval
          customerReport={customerReport}
          userTokenData={userTokenData}
          handleClose={(isOpen: boolean, data?: ICustomerReport) => {
            handleOpenCloseApprovalModel(isOpen, data);
          }}
          isGoBackAtFinalStep={activeStep === 5 ? true : false}
        />
      )}
      {sendEmailModel.isOpen && (
        <ManageSendEmail
          customerReport={customerReport}
          handleClose={(data: ICustomerReport) => {
            handleOpenCloseSendEmailModel(false, data);
          }}
          // handleClose={(isOpen: boolean) => {
          //   handleOpenCloseSendEmailModel(isOpen);
          // }}
          datacenterId={datacenter._id as string}
          customerId={customer._id as string}
        />
      )}
      {downloadReportModal.isOpen && (
        <ManageDownloadReportDialog
          handleClose={(isOpen: boolean) => {
            handleDownloadReportDialogOpenClose(isOpen);
          }}
          datacenterId={datacenter._id as string}
          customer={customer}
          date={search.date}
          downloadSingleReport={downloadReport}
        />
      )}
      {/* {configModal.isOpen && (
        <ManageConfigDialog
          customerId={customerId}
          handleClose={(isOpen: boolean) => {
            handleConfigDialogOpenClose(isOpen);
          }}
        />
      )} */}
      {mergeReportModal.isOpen && (
        <ManageMergeDCReportDialog
          handleClose={(data?: ICustomerReport) => {
            handleOpenCloseMergerReportModel(false, data);
          }}
          datacenterId={datacenter._id as string}
          customer={customer}
          customerReport={customerReport}
          date={search.date}
        />
      )}
    </div>
  );
};

export default ReportApprovalStatus;
